export const schemaOrganization = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  url: process.env.GATSBY_SITE_URL,
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Stockholm, Sweden',
    postalCode: '111 24',
    streetAddress: 'Wallingatan 29',
  },
  email: 'info(at)businesswith.se',
  name: 'BusinessWith',
  telephone: '+46 72-002 30 01',
  logo: `${process.env.GATSBY_SITE_URL}/businesswith-logo.png`,
  termsOfService: `${process.env.GATSBY_SITE_URL}/legal/terms-of-use/`,
  sameAs: [
    'https://www.facebook.com/BusinessWith-softwares-2147009188950621/',
    'https://www.linkedin.com/company/businesswith-software/',
  ],
});
